import { Link } from 'react-router-dom';
import moment from 'moment';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { ICONS, PATHS } from '../../common/constants';
import { selectSearch } from '../../store/selectors/search';
import IcoMoon from '../IcoMoon';
import Label from '../Label';
import Status from '../Status';
import Table from '../Table';
import { selectAuthenticatedUser } from '../../store/selectors/auth';
import { selectLoader } from '../../store/selectors/loader';
import InfiniteScroll from "react-infinite-scroll-component";
import Loader from '../Loader';
import { selectFormLoader } from '../../store/selectors/FormLoader';
import { convertLocalTime } from '../../helpers/validationHelper';
import { variables } from '../../Tenants';

class ReportingTable extends Component {

  state = {
    hasMoreRecords: true,
  }

  render() {
    const { reports} = this.props;
    return (
      <>       

        {reports && reports.length > 0 ? (
          <>
            
            <div
              id="scrollableDiv"
              style={{
                height: 500,
                overflow: "auto",
                display: "flex",
                flexDirection: "column"
              }}
            >
                         
              <InfiniteScroll
                dataLength={reports.length}
                style={{ display: "flex", flexDirection: "column" }}
                inverse={false}
                scrollableTarget="scrollableDiv"
              >
                <Table
                  columns={[
                    {
                      // xsHide: true,
                      sortable: true,
                      label: 'Client',
                      cell: data => {
                        return (
                          <Link
                          to={{pathname: PATHS.SERVICE_REQUESTS_VIEW.replace(':id', data.id), 
                            state: { navigateTo: this.props.navigateTo}      
                        }}
                        >
                        {data.propertyName}
                        </Link>
                        )
                      }
                    },
                    {
                      label: `${variables.serviceRequest} ID`,
                      accessor: 'number',
                      cell: data => {
                        return (
                          data.ticketNumber ? data.ticketNumber : data.ticketId
                        )
                      }
                    },
                  
                     {
                      label: `${variables.serviceRequest} Status`,
                      cell: data => (
                        <Status
                          icon={(
                            <IcoMoon
                              glyph={ICONS[data.status]}
                            />
                          )}
                          label={data.status}
                        />
                      )
                    },
                    {
                      label: `${variables.serviceRequest} Age`,
                      cell: data => (
                        data.serviceRequestAge
                      )
                    },
                    {
                      xsHide: true,
                      label: `${variables.serviceRequest} Created Date`,
                      cell: data => {
                        const days = moment().diff(moment(data.createdDate), 'days');
                        const color = days <= 30 ? 'teal' : days <= 60 ? 'yellow' : 'red';
                        return (
                          <Label
                            color={color}
                            label={convertLocalTime(data.createdDate)}
                          />
                        )
                      }
                    },
                    {
                      xsHide: true,
                      label: `${variables.serviceRequest} Closed Date`,
                      cell: data => {
                        const days = moment().diff(moment(data.closedDate), 'days');
                        const color = days <= 30 ? 'teal' : days <= 60 ? 'yellow' : 'red';
                        return (
                          data.closedDate ?
                          <Label
                            color={color}
                            label={moment(data.closedDate).format('MM/DD/YYYY')}
                          />
                          : null 
                        )
                      }
                    },
                    {
                      xsHide: true,
                      label: 'Estimated Time',
                      cell: data => {
                        return (
                          data.estimatedTime 
                        )
                      }
                    },
                    {
                      xsHide: true,
                      label: 'Actual Time',
                      cell: data => (
                        data.actualTime
                      )
                    }
                  ]}
                  data={reports}
                />
              </InfiniteScroll>
            </div>
          </>
        ) : (
            null
          )}
      </>
    );
  }
}

const mapStateToProps = state => ({
  search: selectSearch(state),
  user: selectAuthenticatedUser(state),
  loader: selectLoader(state),
  formLoader: selectFormLoader(state)
});

const mapDispatchToProps = dispatch => bindActionCreators({
  
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ReportingTable);
